import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsResultsBrowse.module.scss";
import {useSongsResultsBrowseLogic} from "./SongsResultsBrowse.logic";
import {SongCard} from "../../../components/common/song-card/SongCard";

export interface ISongsResultsBrowseProps {
}

export const SongsResultsBrowse: VoidFunctionComponent<ISongsResultsBrowseProps> = () => {
  const {totalSongs, totalFilteredSongs, filteredSongs} = useSongsResultsBrowseLogic();
  return (
    <div className={s.songsResults}>
      {filteredSongs.map((songCardProps) => <SongCard key={`song-results-card-${songCardProps.songId}`} {...songCardProps} />)}
      <div className={s.songsTally}> {totalFilteredSongs} / {totalSongs} results </div>
    </div>
  );
}

